// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3LR-4","inner":"Form_inner__3Ml7W","range":"Form_range__1bNZ_","name":"Form_name__1NM_G","actions":"Form_actions__3BGgA"};